import { render } from "./list-financial.vue?vue&type=template&id=87dfc1e8&scoped=true"
import script from "./list-financial.vue?vue&type=script&lang=js"
export * from "./list-financial.vue?vue&type=script&lang=js"

import "./list-financial.vue?vue&type=style&index=0&id=87dfc1e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87dfc1e8"]])

export default __exports__